import { ExtendSitecore } from './sitecore-extend'

export default {
  install(Vue, VueRoot) {
    ExtendSitecore(Vue, VueRoot)
  }
}
